import { EventSearchPage } from '@/features/events/routes/EventSearchPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/$filter/')({
  component: EventSearchPage,
});
